import fileSaver from 'lib/file-saver';
import { DOWNLOAD_CUSTOM_COVER_PREVIEW_API } from '../constants/AppConstants';

export default async (requestBody) => {
  try {
    const response = await fetch(DOWNLOAD_CUSTOM_COVER_PREVIEW_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
    });

    if (response.status !== 200) throw new Error();

    // Extract filename from header
    const contentDispositionHeader = response.headers.get('Content-Disposition');
    // #genai Preserve the original null/empty-header short-circuit without an incomplete optional chain.
    const filename = contentDispositionHeader
      ? contentDispositionHeader.split(';')
        .find((n) => n.includes('filename='))
        .replace('filename=', '')
        .trim()
      : contentDispositionHeader;

    const blob = await response.blob();

    // Download the file
    fileSaver.saveAs(blob, filename);

    return { ok: true };
  } catch (error) {
    return { ok: false };
  }
};
